




















import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class CoinFlip extends Vue {
  // DATA
  heads: any = null;
  flipping: boolean = false;

  // METHODS
  flipCoin() {
    this.flipping = true;
    setTimeout(() => {
      Math.random() > 0.5 ? (this.heads = true) : (this.heads = false);
      this.flipping = false;
    }, 500);
  }
}
